import { Alert, Snackbar } from "@mui/material";
import React from "react";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";


function CustomSnackbar({
  open,
  onClose,
  message,
  severity = "success",
  autoHideDuration = 3000,
}) {
  const handleClose = (event, reason) => {
    if (reason === "clickaway") return;
    if (onClose) onClose();
  };

  const getBgColor = () => {
    switch (severity) {
      case "success":
        return "#673AB7"; // your brand green
      case "error":
        return "#FF4D4F";
      case "warning":
        return "#FAAD14";
      case "info":
        return "#1677FF";
      default:
        return "#673AB7";
    }
  };

  return (
    <Snackbar
      open={open}
      autoHideDuration={autoHideDuration}
      onClose={handleClose}
      
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
    >
      <Alert
        elevation={6}
        variant="filled"
        onClose={handleClose}
   icon={
    severity === "error"
      ? <InfoOutlinedIcon fontSize="inherit" />
      : undefined
  } sx={{
          backgroundColor: getBgColor(),
          color: "#fff",
          fontWeight: 500,
          alignItems: "center"
        }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
}

export default CustomSnackbar;
